import PropTypes from 'prop-types'
import IconLove from 'src/assets/img/realtalk/love_icon.svg'
import { LvCharacter } from './LevelCharacter'

export const SettingLvCharacter = ({ loveLvSettings, character, expandTalk }) => (
  <>
    {loveLvSettings.level && character.name && (
      <div
        className={`fixed top-[50px] z-[100] transition-all duration-700 ease-in-out transform ${
          expandTalk
            ? '-right-[100px] sm:left-[calc(50%+300px)] opacity-0'
            : 'right-0 sm:left-[calc(50%+100px)] opacity-100'
        } sm:right-auto text-[12px] font-MPlus1 text-left font-medium`}
      >
        <LvCharacter
          level={loveLvSettings.level.love.level}
          name={character.name}
          icon={IconLove}
        />
      </div>
    )}
  </>
)

SettingLvCharacter.propTypes = {
  loveLvSettings: PropTypes.object,
  character: PropTypes.object,
  expandTalk: PropTypes.bool
}
